<template>
  <div v-if="has_settings" class="filter-price-range">
    <div class="filter-price-range__labels">
      <span>{{ format_price(current_min) }}</span>
      <span> - </span>
      <span>{{ format_price(current_max) }}</span>
    </div>
    <vb-range-slider
      :key="slider_key"
      @change="on_change"
      :vb_options="{
        items: filter_price_settings.values,
        inputs: false,
        min: filter_price_range.min !== undefined ? filter_price_range.min : filter_price_settings.min,
        max: filter_price_range.max !== undefined ? filter_price_range.max : filter_price_settings.max,
        min_angle: filter_price_settings.min,
        max_angle: filter_price_settings.max,
      }"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get_markup } from "@liveflight/utilities/flight-offer";
import { number } from "mathjs";

export default {
  name: "filter-price-range",
  computed: {
    ...mapState('liveflight', [
      'filter_price_settings',
      'filter_price_range',
      'results',
    ]),
    flights() {
      return this.results.flights || [];
    },
    has_settings() {
      return (this.filter_price_settings.values || []).length > 0;
    },
    slider_key() {
      return `${this.filter_price_settings.min}-${this.filter_price_settings.max}-${(this.filter_price_settings.values || []).length}`;
    },
    current_min() {
      return this.filter_price_range.min !== undefined ? this.filter_price_range.min : this.filter_price_settings.min;
    },
    current_max() {
      return this.filter_price_range.max !== undefined ? this.filter_price_range.max : this.filter_price_settings.max;
    },
  },
  watch: {
    flights: {
      handler(flights) {
        if (!flights || flights.length === 0) return;
        this.compute_settings(flights);
      },
      immediate: true,
    },
  },
  methods: {
    compute_settings(flights) {
      const prices = flights.map(f => number(get_markup(f).mu_price));
      const min_price = Math.floor(Math.min(...prices));
      const max_price = Math.ceil(Math.max(...prices));

      if (min_price === max_price) return;

      const bucket_count = Math.min(15, Math.max(5, Math.ceil(prices.length / 3)));
      const step = (max_price - min_price) / bucket_count;
      const values = [];

      for (let i = 0; i < bucket_count; i++) {
        const bucket_min = min_price + step * i;
        const bucket_max = i === bucket_count - 1 ? max_price : min_price + step * (i + 1);
        const count = prices.filter(p => p >= bucket_min && (i === bucket_count - 1 ? p <= bucket_max : p < bucket_max)).length;
        values.push({ min: Math.floor(bucket_min), max: Math.ceil(bucket_max), count });
      }

      this.$store.commit("liveflight/filter_price_settings", {
        min: min_price,
        max: max_price,
        values,
      });

      this.$store.commit("liveflight/filter_price_range", {
        min: min_price,
        max: max_price,
      });
    },
    format_price(val) {
      return `€ ${Math.floor(val).toLocaleString('it-IT')}`;
    },
    on_change(e) {
      if (e.dragging) return;
      const current = this.filter_price_range;
      this.$store.commit("liveflight/filter_price_range", {
        min: e.min !== undefined ? e.min : current.min,
        max: e.max !== undefined ? e.max : current.max,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-price-range {
  &__labels {
    position: absolute;
    top: 4px;
    right: 4px;
    display: flex;
    justify-content: flex-end;
    font-size: $font-size-md;
    //font-weight: $vb-font-weight-semibold;
    color: $dark;
    margin-bottom: 4px;
    &>span {
      display: inline-block;
      padding: 0 2px;
    }
  }
}
</style>
